var _path, _path2, _g, _g2, _path3, _circle, _circle2, _circle3, _circle4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 185,
    viewBox: "0 0 246 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 101.776C0 123.002 7.65204 142.344 20.244 156.962C34.6898 173.737 55.6376 184.285 78.9876 184.32C89.1925 184.335 98.9502 182.33 107.913 178.669C112.547 176.776 117.734 176.993 122.223 179.236C127.488 181.864 133.383 183.338 139.609 183.338C142.18 183.338 144.699 183.085 147.135 182.604C154.088 181.237 160.416 178.001 165.613 173.419C168.879 170.537 173.061 169.089 177.336 169.094H177.409C191.534 169.094 204.655 164.623 215.549 156.962C225.288 150.122 233.241 140.734 238.54 129.711C243.159 120.105 245.76 109.255 245.76 97.7704C245.76 58.3819 215.156 26.4465 177.409 26.4465C173.561 26.4465 169.791 26.7857 166.113 27.4185C156.374 10.9671 138.934 0 119.039 0C110.64 0 102.677 1.95466 95.5487 5.45855C88.7701 8.77995 82.7431 13.4995 77.8129 19.2512C61.0721 19.5297 45.5926 25.2364 32.9231 34.7604C12.9799 49.7435 0 74.1798 0 101.776Z",
    fill: "url(#paint0_linear_2458_6233)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 101.776C0 123.002 7.65204 142.344 20.244 156.962C34.6898 173.737 55.6376 184.285 78.9876 184.32C89.1925 184.335 98.9502 182.33 107.913 178.669C112.547 176.776 117.734 176.993 122.223 179.236C127.488 181.864 133.383 183.338 139.609 183.338C142.18 183.338 144.699 183.085 147.135 182.604C154.088 181.237 160.416 178.001 165.613 173.419C168.879 170.537 173.061 169.089 177.336 169.094H177.409C191.534 169.094 204.655 164.623 215.549 156.962C225.288 150.122 233.241 140.734 238.54 129.711C243.159 120.105 245.76 109.255 245.76 97.7704C245.76 58.3819 215.156 26.4465 177.409 26.4465C173.561 26.4465 169.791 26.7857 166.113 27.4185C156.374 10.9671 138.934 0 119.039 0C110.64 0 102.677 1.95466 95.5487 5.45855C88.7701 8.77995 82.7431 13.4995 77.8129 19.2512C61.0721 19.5297 45.5926 25.2364 32.9231 34.7604C12.9799 49.7435 0 74.1798 0 101.776Z",
    fill: "url(#paint1_linear_2458_6233)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.227 38.7264C137.937 38.7264 136.647 38.2363 135.665 37.2556C133.701 35.2944 133.701 32.1035 135.665 30.1426C137.628 28.182 140.825 28.1813 142.789 30.1426C144.754 32.1038 144.754 35.2947 142.789 37.2556C141.808 38.2363 140.518 38.7264 139.227 38.7264ZM139.227 32.1388C138.827 32.1388 138.427 32.2908 138.121 32.5953C137.512 33.2038 137.512 34.1941 138.121 34.8029C138.732 35.4113 139.723 35.4116 140.333 34.8029C140.942 34.1944 140.942 33.2041 140.333 32.5953C140.028 32.2911 139.627 32.1388 139.227 32.1388Z",
    fill: "#919EAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6217 156.16C98.3316 156.16 97.0412 155.669 96.0593 154.689C94.0948 152.728 94.0948 149.537 96.0593 147.576C98.0231 145.615 101.22 145.615 103.184 147.576C105.149 149.537 105.149 152.728 103.184 154.689C102.202 155.67 100.912 156.16 99.6217 156.16ZM99.6217 149.572C99.2214 149.572 98.8208 149.724 98.5158 150.029C97.9063 150.637 97.9063 151.628 98.5158 152.236C99.1259 152.845 100.117 152.845 100.727 152.236C101.337 151.628 101.337 150.638 100.727 150.029C100.423 149.725 100.022 149.572 99.6217 149.572Z",
    fill: "#919EAB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.703 132.47C187.258 132.47 186.813 132.301 186.475 131.963L184.402 129.894L182.33 131.963C181.652 132.64 180.551 132.64 179.873 131.963C179.195 131.285 179.195 130.187 179.873 129.51L183.174 126.214C183.852 125.537 184.952 125.537 185.63 126.214L188.931 129.51C189.61 130.187 189.61 131.285 188.931 131.963C188.592 132.301 188.147 132.47 187.703 132.47Z",
    fill: "#919EAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1707 125.862C64.7263 125.862 64.2813 125.693 63.9425 125.355L61.87 123.286L59.7974 125.355C59.1196 126.032 58.0188 126.032 57.341 125.355C56.6624 124.677 56.6624 123.579 57.341 122.902L60.6417 119.606C61.3196 118.929 62.4203 118.929 63.0982 119.606L66.399 122.902C67.0775 123.579 67.0775 124.677 66.399 125.355C66.0598 125.693 65.6151 125.862 65.1707 125.862Z",
    fill: "#919EAB"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.16 103.88L153.36 123.08",
    stroke: "#919EAB",
    strokeWidth: 6.4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116.24,
    cy: 87.24,
    r: 23.04,
    fill: "white",
    fillOpacity: 0.6,
    stroke: "#C2C8CD",
    strokeWidth: 6.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 87.2397,
    r: 2.56,
    fill: "#919EAB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 116.24,
    cy: 87.2397,
    r: 2.56,
    fill: "#919EAB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 126.48,
    cy: 87.2397,
    r: 2.56,
    fill: "#919EAB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2458_6233",
    x1: 168.351,
    y1: 217.104,
    x2: 258.761,
    y2: 13.3365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919EAB",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2458_6233",
    x1: 168.351,
    y1: 217.104,
    x2: 258.761,
    y2: 13.3365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919EAB",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.dcd85124aed3f835a1c8e62661fb035d.svg";
export { ForwardRef as ReactComponent };